console.log('MEDIA-GALLERY JS FILE LOADED');

if (!customElements.get('media-gallery')) {
  console.log('DEFINING MEDIA-GALLERY');

  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        console.log('✅ MediaGallery initialized');

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        };

        console.log('Viewer:', this.elements.viewer);
        console.log('Thumbnails:', this.elements.thumbnails);

        this.mql = window.matchMedia('(min-width: 750px)');
        this.prependMedia = this.dataset.disablePrepend !== 'true';

        if (!this.elements.viewer) {
          console.warn('❌ MediaGallery viewer not found');
          return;
        }

        this.onThumbnailClick = this.onThumbnailClick.bind(this);
        this.onSlideChanged = this.onSlideChanged.bind(this);

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged, 500)
        );

        if (this.elements.thumbnails) {
          this.elements.thumbnails.addEventListener('click', this.onThumbnailClick, true);

          this.elements.thumbnails.querySelectorAll('.slider-button').forEach((btn) => {
            btn.addEventListener('click', () => {
              console.log('➡️ Thumbnail slider arrow clicked:', btn);
            });
          });
        }

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onThumbnailClick(event) {
        console.log('🔥 Click inside thumbnails area');
        console.log('Clicked element:', event.target);

        const sliderArrow = event.target.closest('.slider-button');
        if (sliderArrow) {
          console.log('➡️ This was a slider arrow, not a thumbnail');
          return;
        }

        const button = event.target.closest('button');
        console.log('Button found:', button);

        if (!button) return;

        const thumbnailItem = button.closest('[data-target]');
        console.log('Thumbnail item:', thumbnailItem);

        if (!thumbnailItem) {
          console.warn('❌ No [data-target] parent found');
          return;
        }

        const mediaId = thumbnailItem.dataset.target;
        console.log('Media ID from thumbnail:', mediaId);

        if (!mediaId) {
          console.warn('❌ No mediaId found on thumbnail item');
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        this.setActiveMedia(mediaId, false);
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;

        const mediaId = event?.detail?.currentElement?.dataset?.mediaId;
        console.log('slideChanged fired. mediaId:', mediaId);

        if (!mediaId) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

        console.log('Thumbnail found from slideChanged:', thumbnail);

        if (!thumbnail) {
          console.warn('❌ Thumbnail not found on slideChanged for mediaId:', mediaId);
          return;
        }

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend = false) {
        console.log('🚀 setActiveMedia called with:', mediaId);

        if (!this.elements.viewer) {
          console.warn('❌ Viewer missing');
          return;
        }

        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        console.log('Active media element:', activeMedia);

        if (!activeMedia) {
          console.warn('❌ Media NOT FOUND for:', mediaId);
          return;
        }

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        console.log('✅ is-active added to:', activeMedia);

        if (prepend && this.prependMedia) {
          const mediaList = activeMedia.parentElement;

          if (mediaList) {
            mediaList.prepend(activeMedia);
            console.log('✅ Active media prepended');
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );

            console.log('Active thumbnail for prepend:', activeThumbnail);

            if (activeThumbnail && activeThumbnail.parentElement) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (
            this.elements.viewer.slider &&
            typeof this.elements.viewer.resetPages === 'function'
          ) {
            this.elements.viewer.resetPages();
            console.log('✅ Viewer pages reset');
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          const mediaList = activeMedia.parentElement;

          if (mediaList) {
            mediaList.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: 'smooth'
            });
          }

          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest'
            });
          }
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

        console.log('Active thumbnail element:', activeThumbnail);

        if (!activeThumbnail) {
          console.warn('❌ Thumbnail not found for mediaId:', mediaId);
          return;
        }

        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition || '');
      }

      setActiveThumbnail(thumbnail) {
  console.log('setActiveThumbnail called with:', thumbnail);

  if (!this.elements.thumbnails || !thumbnail) return;

  this.elements.thumbnails
    .querySelectorAll('button')
    .forEach((element) => element.removeAttribute('aria-current'));

  const button = thumbnail.querySelector('button');
  if (!button) {
    console.warn('❌ No button inside thumbnail');
    return;
  }

  button.setAttribute('aria-current', 'true');
  console.log('✅ aria-current set on thumbnail button');

  // More reliable auto-scroll for horizontal thumbnail strips
  thumbnail.scrollIntoView({
    behavior: 'smooth',
    block: 'nearest',
    inline: 'center'
  });
}
     

      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion || !activeItem) return;

        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image || !window.accessibilityStrings?.imageAvailable) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'false');
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace('[index]', position);

          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (!activeItem) return;

        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer?.slider || !this.elements.viewer?.sliderItems) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  );
}